import { cdnEndpoints } from './cdn-endpoints.function';
import { firebaseConfigProd } from './firebase/firebase.prod';

const apiGateway = 'https://api-prod-centralus2.sancristobal.com.ar/';
const apiManagement = 'https://edge.azure-api.net/';
const cdnBaseUrl = 'https://content.gruposancristobal.com/';

const apiBaseUrl = apiManagement;

export const environment = {
  version: require('../../package.json').version,
  dependencies: require('../../package.json').dependencies,
  type: {
    id: 'prod',
    name: 'Production'
  },
  apiBaseUrl: apiBaseUrl,
  production: true,
  legacyPortal: 'https://www2.sancristobal.com.ar/PortalSCNET/Productores/homeproductores.aspx',
  legacyPortalBase: 'https://pas.sancristobal.com.ar/',
  OORRPortalBase: 'https://siniestrosrsvs.sancristobal.com.ar',
  thirdPartyPortalBase: 'https://www.sancristobal.com.ar',
  apiAuthUrl: apiBaseUrl + 'authapi',
  apiClaim: apiBaseUrl + 'claimapi',
  apiAdmin: apiGateway + 'claimadminapi',
  apiCommercialAutoUrl: apiBaseUrl + 'commercialautoapi',
  apiUtilityUrl: apiBaseUrl + 'utilityapi',
  apiNotifications: apiGateway + 'notificationapi',
  account: 'claimimages',
  container: 'claimimages',
  appInsightsKey: '19f7bb32-06eb-4a5a-802e-a362fa83460f',
  hotJarSiteId: 880036,
  apiClaimV2: apiBaseUrl + 'claim/api',
  lender: apiBaseUrl + `lender/api`,
  google: {
    taskManager: {
      token: 'GTM-W5KB3TPL'
    }
  },
  cdn: cdnEndpoints(cdnBaseUrl),
  firebase: firebaseConfigProd,
};
